import { FaChevronRight } from 'react-icons/fa'

import { ButtonLink } from 'src/components/atoms/Link'
import { Heading3 } from 'src/components/atoms/Typography'

type ContextActionBannerProps = {
  backgroundSource: string
  title: string
  description: string | JSX.Element
  cta: { text: string; href: string } | JSX.Element
  className?: string
}

const ContextActionBanner = ({
  backgroundSource,
  title,
  description,
  cta,
  className
}: ContextActionBannerProps) => {
  return (
    <div
      className={`rounded-[10px] bg-center bg-no-repeat bg-cover w-full flex flex-row p-5 md:p-10 justify-end ${className}`}
      style={{
        backgroundImage: `url('${backgroundSource}')`
      }}
    >
      <div className='gap-5 lg:flex-[0_0_50%] flex flex-col bg-aquaSpringLight p-5 md:p-10 rounded-[5px]'>
        <Heading3 className='m-0! text-[24px]! leading-[30px]! font-bold! md:text-[28px]! md:leading-[39px]! md:font-semibold!'>
          {title}
        </Heading3>
        <div className='font-medium'>{description}</div>
        {typeof cta === 'object' && 'href' in cta && 'text' in cta ? (
          <ButtonLink className='md:self-start' size='large' href={cta.href}>
            {cta.text} <FaChevronRight className='ml-[5px]' />
          </ButtonLink>
        ) : (
          cta
        )}
      </div>
    </div>
  )
}

export default ContextActionBanner
